import { render } from "./EventCard.vue?vue&type=template&id=567e34fe&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=567e34fe&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567e34fe"]])

export default __exports__